import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { CheckCircle2 } from "lucide-react";
import { useToast } from "../hooks/use-toast";
import { leadsApi } from "../lib/api";

export default function BookDemoDialog({ open, onOpenChange }) {
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({ name: "", company: "", email: "", size: "", message: "" });
  const { toast } = useToast();

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await leadsApi.create({ name: form.name, company: form.company, email: form.email, message: form.message });
      setDone(true);
      toast({ title: "Demo request received", description: "Our team will reach out within 1 business day." });
      setTimeout(() => { onOpenChange(false); setTimeout(() => { setDone(false); setForm({ name: "", company: "", email: "", size: "", message: "" }); }, 300); }, 1800);
    } catch (err) {
      toast({ title: "Could not send request", description: "Please try again in a moment.", variant: "destructive" });
    } finally {
      setSubmitting(false);
    }
  };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        {done ? (
          <div className="py-8 text-center">
            <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto mb-4" />
            <h3 className="font-display font-bold text-xl text-brand-navy">Thank you!</h3>
            <p className="text-slate-600 mt-2">We've received your request and will be in touch shortly.</p>
          </div>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle className="font-display text-2xl text-brand-navy">Book a Demo</DialogTitle>
              <DialogDescription>See how HRFlo keeps your business compliant. We'll tailor it to your team.</DialogDescription>
            </DialogHeader>
            <form onSubmit={submit} className="space-y-4 mt-2">
              <div className="grid gap-2"><Label>Full name</Label><Input required value={form.name} onChange={set("name")} placeholder="e.g. Onkarabile Dintwe" /></div>
              <div className="grid gap-2"><Label>Company</Label><Input required value={form.company} onChange={set("company")} placeholder="Your business name" /></div>
              <div className="grid gap-2"><Label>Work email</Label><Input required type="email" value={form.email} onChange={set("email")} placeholder="you@company.co.bw" /></div>
              <div className="grid gap-2"><Label>Message (optional)</Label><Textarea value={form.message} onChange={set("message")} placeholder="Tell us about your team..." /></div>
              <Button type="submit" disabled={submitting} className="w-full bg-brand-blue hover:bg-brand-bluedark text-white rounded-lg h-11">{submitting ? "Sending..." : "Request demo"}</Button>
            </form>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
